import { useTranslation } from "react-i18next";
import { ReactComponent as ContactPhoto } from "assets/svgs/R2C2Logo.svg";

const PHONE_DISPLAY = "+852 6423 2543";
const PHONE_HREF = "tel:+85264232543";
const MAIL_DISPLAY = "info@r2c2.ai";
const MAIL_HREF = "mailto:info@r2c2.ai";

const ContactUsPanel: React.FC = () => {
    const { t } = useTranslation("settings");

    return (
        <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col">
            <div className="shrink-0 border-b border-black80 pb-4">
                <p className="text-h4 font-semibold text-white">{t("contactUs.title")}</p>
            </div>
            <div className="mt-6 flex min-h-0 max-w-md flex-row items-center gap-6">
                <div className="h-32 w-32 shrink-0 overflow-hidden rounded-full border-2 border-black80 ring-2 ring-primary2/40">
                    <ContactPhoto
                        aria-label="R2C2"
                        className="h-full w-full object-cover object-top"
                    />
                </div>
                <div className="flex min-w-0 flex-col justify-center">
                    <p className="text-h4 font-semibold text-white">R2C2 Support</p>
                    <a
                        href={PHONE_HREF}
                        className="mt-2 inline-block text-h5 text-primary2 hover:text-primary1"
                    >
                        {PHONE_DISPLAY}
                    </a>
                    <a
                        href={MAIL_HREF}
                        className="mt-2 inline-block text-h5 text-primary2 hover:text-primary1"
                    >
                        {MAIL_DISPLAY}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ContactUsPanel;
